@if (row) {
  <div style="min-width: 240px;">
    <table>
      <tr>
        <td colspan="3">
          <strong>Acct&nbsp;{{row.accountNum}}
            @if (row.liquidated) {
              <span style="padding-left:10px;color:#b70404;">LIQD</span>
            }
          </strong>
        </td>
      </tr>
      <tr>
        <td nowrap>{{row.accountName}}</td>
        <td nowrap>{{row.accountSubType}}</td>
        <td nowrap>{{row.accountLocationType}}</td>
      </tr>
    </table>
    <hr/>
    <table width='100%'>
      <tr>
        <td></td>
        <td class="alignRight">Percent</td>
        <td class="alignRight">Dollar</td>
      </tr>
      @if (isCashEqvEnabled) {
      <tr>
        <td>Cash Only Min</td>
        @if (row.cashOnlyMinPerc) {
          <td class="alignRight">{{row.cashOnlyMinPerc | number: "1.2-2" }}%</td>
        }
        @if (!row.cashOnlyMinPerc) {
          <td class="alignRight">--</td>
        }
        <td class="alignRight">${{row.cashOnlyMin | number: "1.2-2"}}</td>
      </tr>
      }
      <tr>
        <td>Cash Min</td>
        @if (row.cashMinPerc) {
          <td class="alignRight">{{row.cashMinPerc | number: "1.2-2" }}%</td>
        }
        @if (!row.cashMinPerc) {
          <td class="alignRight">--</td>
        }
        <td class="alignRight">${{row.cashMin | number: "1.2-2"}}</td>
      </tr>
      <tr>
        <td>Cash Target</td>
        @if (row.cashTargetPerc) {
          <td class="alignRight">{{row.cashTargetPerc | number: "1.2-2" }}%</td>
        }
        @if (!row.cashTargetPerc) {
          <td class="alignRight">--</td>
        }
        <td class="alignRight">${{row.cashTarget | number: "1.2-2"}}</td>
      </tr>
      <tr>
        <td>Cash Max</td>
        @if (row.cashMaxPerc) {
          <td class="alignRight">{{row.cashMaxPerc | number: "1.2-2" }}%</td>
        }
        @if (!row.cashMaxPerc) {
          <td class="alignRight">--</td>
        }
        <td class="alignRight">${{row.cashMax | number: "1.2-2"}}</td>
      </tr>
      <tr>
        <td>Set-aside Cash</td>
        @if (row.setAsideCashPerc) {
          <td class="alignRight">{{row.setAsideCashPerc | number: "1.2-2" }}%</td>
        }
        @if (!row.setAsideCashPerc) {
          <td class="alignRight">--</td>
        }
        <td class="alignRight">${{row.accountSetAsideCash | number: "1.2-2"}}</td>
      </tr>
      <tr>
        <td>Extra Cash</td>
        <td class="alignRight">--</td>
        <td class="alignRight">${{row.accountExtraCash | number: "1.2-2"}}</td>
      </tr>
      @if (row.accountShortCash !== 0) {
        <tr>
          <td>Short Cash</td>
          <td class="alignRight">--</td>
          <td class="alignRight">${{row.accountShortCash | number: "1.2-2"}}</td>
        </tr>
      }
      @if (isDistHoldCashEnabled) {
        <tr>
          <td>Distribution Hold</td>
          @if (row.distributionHoldPerc) {
            <td class="alignRight">{{row.distributionHoldPerc | number: "1.2-2"}}%</td>
          }
          @if (!row.distributionHoldPerc) {
            <td class="alignRight">--</td>
          }
          <td class="alignRight">${{row.distributionHoldAmt | number: "1.2-2"}}</td>
        </tr>
      }
    </table>
  </div>
}
